import React, { Component } from "react";
import Slide from "./Slide";
import PropTypes from "prop-types";

function mod(a, b) {
  return ((a % b) + b) % b;
}

class VerticalCarousel extends Component {
  state = {
    index: 0,
  };

  componentDidMount() {
    document.addEventListener("keydown", (event) => {
      if (event.keyCode === 38) this.moveSlide(-1);
      if (event.keyCode === 40) this.moveSlide(1);
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.currentIndex !== this.props.currentIndex) {
      this.setState({ index: this.props.currentIndex });
    }
  }

  moveSlide = (direction) => {
    const newIndex = this.modBySlidesLength(this.state.index + direction);
    this.setState({ index: newIndex });
    if (this.props.onIndexChange) {
      this.props.onIndexChange(newIndex);
    }
  };

  goToSlide = (targetIndex) => {
    this.setState({ index: targetIndex });
    if (this.props.onIndexChange) {
      this.props.onIndexChange(targetIndex);
    }
  };

  static propTypes = {
    slides: PropTypes.array.isRequired,
    offsetRadius: PropTypes.number,
    animationConfig: PropTypes.object,
    currentIndex: PropTypes.number,
    onIndexChange: PropTypes.func,
    onImageClick: PropTypes.func,
  };

  static defaultProps = {
    offsetRadius: 2,
    animationConfig: { tension: 120, friction: 14 },
    currentIndex: 0,
  };

  modBySlidesLength = (index) => mod(index, this.props.slides.length);

  clampOffsetRadius(offsetRadius) {
    const { slides } = this.props;
    const upperBound = Math.floor((slides.length - 1) / 2);
    return Math.max(0, Math.min(offsetRadius, upperBound));
  }

  getPresentableSlides() {
    const { slides } = this.props;
    const { index } = this.state;
    const offsetRadius = this.clampOffsetRadius(this.props.offsetRadius);
    const presentableSlides = [];

    for (let i = -offsetRadius; i <= offsetRadius; i++) {
      presentableSlides.push(slides[this.modBySlidesLength(index + i)]);
    }

    return presentableSlides;
  }

  render() {
    const { offsetRadius, showNavigation, slides } = this.props;

    return (
      <>
        <div className="carousel-wrapper">
          <div className="carousel-pagination pag-dots">
            {slides.map((_, i) => (
              <div
                className={`carousel-dot dots ${i === this.state.index ? "is-active" : ""}`}
                key={i}
                onClick={() => this.goToSlide(i)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") this.goToSlide(i);
                }}
              />
            ))}
          </div>

          {this.getPresentableSlides().map((slide, presentableIndex) => (
            <Slide
              key={slide.key}
              image={slide.image}
              slide={slide}
              moveSlide={this.moveSlide}
              offsetRadius={this.clampOffsetRadius(offsetRadius)}
              index={presentableIndex}
              animationConfig={this.props.animationConfig}
              onImageClick={this.props.onImageClick}
            />
          ))}
        </div>

        {showNavigation && (
          <div className="carousel-nav-buttons">
            <div className="carousel-nav-btn" onClick={() => this.moveSlide(-1)}>
              &#8593;
            </div>
            <div className="carousel-nav-btn" onClick={() => this.moveSlide(1)}>
              &#8595;
            </div>
          </div>
        )}
      </>
    );
  }
}

export default VerticalCarousel;
